import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';
import { ensureUser, ensureCurrentUser } from '../../../util/data';

import { AvatarLarge, Button, IconButtonArrow } from '../../../components';

import css from './ProfileCard.module.css';

// Approximated collapsed size so that there are ~three lines of text
// in the desktop layout in the author section of the ListingPage.
const BIO_COLLAPSED_LENGTH = 170;
const MIN_LENGTH_FOR_LONG_WORDS = 20;

const ProfileCard = props => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  const { user, currentUser, listing, onContactUser, isOwnListing } = props;

  const userIsCurrentUser = user && user.type === 'currentUser';
  const ensuredUser = userIsCurrentUser ? ensureCurrentUser(user) : ensureUser(user);
  const ensuredCurrentUser = ensureCurrentUser(currentUser);
  const { displayName } = ensuredUser.attributes.profile;
  const { address } = listing?.attributes?.publicData?.location || {};


  return (
    <div className={css.root}>
      <div className={css.content}>
        <AvatarLarge className={css.avatar} user={user} disableProfileLink />
        <div className={css.headingHolder}>
          <h2 className={css.heading}>
            <FormattedMessage id="UserCard.profileheading" values={{ name: displayName, lineBreak: <br /> }} />
          </h2>

          {address && (
            <p className={css.location}>
              {address}
            </p>
          )}

          {!isOwnListing && (
            <Button
              type="button"
              className={css.messageEducator}
              onClick={() => onContactUser()}
            >
              <FormattedMessage id="UserCard.messageEducator" />
              <IconButtonArrow />
            </Button>
          )}

        </div>

      </div>
    </div>
  );
};

export default ProfileCard;
